import { useContext, useEffect } from 'react'

import { Formik, FormikProps, FormikValues } from 'formik'

import each from 'lodash/each'
import max from 'lodash/max'

import { Context as StateContext } from '../../StateContext'
import { getCurrentQuestionIndex } from '../../utilities'
import Question from './Question'

const Questions = () => {
  const { state, dispatch } = useContext(StateContext)

  const initialValues = {
    answers: state.answers,
    questions: state.questions,
  }

  const activeStepIndex = Boolean(state.currentQuestionId)
    ? getCurrentQuestionIndex(state, state.currentQuestionId)
    : 0

  const onSubmit = ({ answers }) =>
    each(answers, (data, questionId) =>
      dispatch({
        type: 'answer',
        questionId,
        data,
      })
    )

  const question = state.questions[activeStepIndex]

  useEffect(() => {
    if (!Boolean(state.content.timeLimit)) {
      return
    }

    const interval = setInterval(() => {
      dispatch({
        type: 'set-timer',
        value: max([state.remainingTime - 10, 0]),
      })
    }, 10000)

    return () => clearInterval(interval)
  }, [dispatch, state.remainingTime, state.content.timeLimit])

  if (!question) return 'Questo quiz è vuoto'

  return (
    <div className="flex flex-col gap-y-4">
      <Formik
        activeStepIndex={activeStepIndex}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {(formikProps: FormikProps<FormikValues>) => (
          <Question
            answer={state.answers?.[question.id] || {}}
            formikProps={formikProps}
            index={activeStepIndex}
            key={question.id}
            question={question}
          />
        )}
      </Formik>
    </div>
  )
}

export default Questions
